module.exports = __webpack_public_path__ + "img/Sorting1.dd482a08.png";